import React from 'react';

export default function SectionTitle({ children, className = '' }) {
  return (
    <div className={`bg-orange-500 rounded-tl-2xl rounded-br-2xl px-6 py-2 mb-4 shadow text-white font-bold text-2xl tracking-wider inline-block ${className}`}
      style={{ fontFamily: 'Mukta, Arial, sans-serif', letterSpacing: '0.04em' }}>
      {children}
    </div>
  );
} 